// Credentials that must never be returned by the public siteSettings query
// or copied into window.APP_STATE. Read them on the server only.
const PRIVATE_SITE_SETTING_NAMES = [
  'platformSecretKey',
  'veriffAPIKey',
  'veriffSecretKey',
];

export default PRIVATE_SITE_SETTING_NAMES;
